type GetThemeSpacingReturnType<T extends boolean> = T extends true
    ? number
    : string

export const getThemeSpacing = <T extends boolean>(
    amount = 1,
    onlyNumber?: T,
): GetThemeSpacingReturnType<T> => {
    const pxValue = amount * 8
    if (onlyNumber) return pxValue as GetThemeSpacingReturnType<T>
    return `${pxValue}px` as GetThemeSpacingReturnType<T>
}
